export default {
  from: state => state.from,
  _key: state => (state.params && state.params._key ? state.params._key : ''),
  keyParent: state => (state.params && state.params.keyParent ? state.params.keyParent : ''),
  crumbs: state => (state.meta && state.meta.crumbs ? state.meta.crumbs : ''),
};
